<script setup lang="ts">
import { computed } from 'vue'
import Progress from '@/components/ui/Progress.vue'

interface Props {
  value: number // 0-100
  variant?: 'primary' | 'success' | 'warning' | 'danger'
  size?: 'sm' | 'md' | 'lg'
  showLabel?: boolean
  indeterminate?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
  size: 'sm',
  showLabel: false,
  indeterminate: false,
})

const safeValue = computed(() => {
  if (!Number.isFinite(props.value)) return 0
  return Math.max(0, Math.min(100, props.value))
})
</script>

<template>
  <Progress
    :value="safeValue"
    :variant="variant"
    :size="size"
    :show-label="showLabel"
    :indeterminate="indeterminate"
  />
</template>